import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import CarContext from '../../context/CarContext';

const Button = styled.button`
    padding: 0.5rem;
    background-color: #c8372f;
    color: white;
    border: none;
    border-radius: 0.375rem;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #ec3a30;
    }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  width: 80%;
  height: 80%;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;

  &:hover {
    color: #374151;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0.5rem;
`;

const Autokuva = ({ hasOutside }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const {car: {registrationNumber}} = useContext(CarContext);

  // const url = `https://files.autokuva.com/bilbolaget/${registrationNumber}/${hasOutside ? "outside" : "inside"}/index.html`;
  const url = `https://files.autokuva.com/bilbolaget/${registrationNumber}/${hasOutside ? "outside" : "inside"}`;

  return (
      <div>
        <Button onClick={openModal}>
          360
        </Button>

        {isModalOpen && (
            <ModalOverlay>
              <ModalContent>
                <CloseButton onClick={closeModal}>&times;</CloseButton>
                <StyledIframe
                    src={url}
                    title="Autokuva 360"
                />
              </ModalContent>
            </ModalOverlay>
        )}
      </div>
  );
};

const AutokuvaWrapper = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const [hasOutside, setHasOutside] = useState(false);

  const {car: {registrationNumber}} = useContext(CarContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await axios.get(`https://files.autokuva.com/bilbolaget/${registrationNumber}/index.json`);
        // if (response.data.inside === true || response.data.outside === true) {
          //   setShouldRender(true);
          //   setHasOutside(response.data.outside === true);
          // }        
        const response = await axios.get(`https://files.autokuva.com/bilbolaget/${registrationNumber}/outside`);
        if(response.status === 200){
          setHasOutside(true);
          setShouldRender(true);
        }

      } catch (error) {
        console.log('No autokuva data found');
        if (error.response && error.response.status !== 404) {
          console.error('Error fetching Autokuva data:', error);
        }
      }
    };

    if(registrationNumber){
      fetchData();
    }
  }, []);

  return shouldRender ? <Autokuva hasOutside={hasOutside} /> : null;
};

export default AutokuvaWrapper;